import { Plugin, PluginId } from "..";
import { defaultTimeHistoryDataOptions } from "./time-history-data-options";
import {
	defaultTimeHistoryOptions,
	TimeHistoryOptionsV1,
	TimeHistoryOptionsV2,
} from "./time-history-options";

const id: PluginId = "timehistory";

export const TimeHistory: Plugin = {
	id,
	type: "history",
	header: {
		visible: true,
		edit: true,
		fullscreen: true,
	},
	name: "timeHistory",
	component: defineAsyncComponent(() => import("./TimeHistoryPlugin.vue")),
	config: defineAsyncComponent(() => import("./TimeHistoryPluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./TimeHistoryDataConfig.vue")),
	defaultDataResolver: () => defaultTimeHistoryDataOptions,
	defaultOptionsResolver: () => defaultTimeHistoryOptions,
	dimension: {
		minHeight: 4,
		minWidth: 8,
	},

	currentVersion: 2,
	migrations: {
		1: ({ data, options }) => {
			let v2Options: TimeHistoryOptionsV2 | null = null;
			if (options != null) {
				const v1Options = options as TimeHistoryOptionsV1;
				v2Options = {
					...v1Options,
					axes: {
						...v1Options.axes,
						left: {
							...v1Options.axes.left,
							logScale: false,
						},
						right: {
							...v1Options.axes.right,
							logScale: false,
						},
					},
				};
			}

			return { data, options: v2Options };
		},
	},
};
